import React, { useMemo } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { isDarkMode } from '../services/helper'
import EqualOpportunityHousingLogo from './icons/EqualOpportunityHousingLogo'
import MobileAppStoreBadges from './MobileAppStoreBadges'

export const Footer = ({
	legalLinks,
	socialLinks,
	siteConfig = {},
}) => {
	const NMLSID = useMemo(() => {
		if ([0, 1, 2].includes(siteConfig.entityType))
			return siteConfig.nmlsid
		else return siteConfig.branchNMLSID
	}, [siteConfig])
	return (
		<div className="p-6 bg-white dark:bg-[#121212]">
			<div className="max-w-screen-xl mx-auto">
				<div className="flex flex-col sm:flex-row mt-12 mb-5 sm:gap-6">
					<div className="text-base font-rubik mb-4 sm:mb-0 text-gray-600 dark:text-gray-400 flex-1">
						{siteConfig && siteConfig.logoUrl && (
							<div className="relative mb-8 w-full max-w-[620px] pt-[120px]">
								<img
									className="absolute top-0 left-0 w-full h-full object-contain sm:object-left"
									src={
										isDarkMode() && siteConfig?.darkModeLogoUrl
											? siteConfig.darkModeLogoUrl
											: siteConfig.logoUrl
									}
									alt="Logo"
								/>
							</div>
						)}
						{!!NMLSID && <p>NMLS #: {NMLSID}</p>}
						<p>{(siteConfig && siteConfig.address) || ''}</p>
						{siteConfig && !!siteConfig.address2 && (
							<p>{siteConfig.address2}</p>
						)}
						<p>
							{[siteConfig?.city, siteConfig?.state, siteConfig?.zip]
								.filter((x) => x)
								.join(', ')}
						</p>
					</div>
					{!!siteConfig?.mobileSettings?.hasMobile && (
						<MobileAppStoreBadges
							universalUrl={
								siteConfig?.mobileSettings?.universalUrl ?? ''
							}
							appStoreUrl={
								siteConfig?.mobileSettings?.appleStoreUrl ?? ''
							}
							googlePlayUrl={
								siteConfig?.mobileSettings?.googlePlayStoreUrl ?? ''
							}
						/>
					)}
					<div className="flex">
						<div className="mr-6">
							<p className="text-lg font-rubik mb-6 text-black font-semibold dark:text-white">
								Legal
							</p>
							<div>
								{legalLinks &&
									legalLinks.map((link, index) => (
										<a
											target="_blank"
											rel="noreferrer"
											href={link.link}
											className="flex mb-4 hover:underline"
											key={`${link.linkItem + index}`}
										>
											<p className="text-base font-rubik text-gray-600 dark:text-gray-400">
												{link.linkItem}
											</p>
										</a>
									))}
							</div>
						</div>
						<div>
							{socialLinks && socialLinks.length > 0 && (
								<>
									<p className="text-lg font-rubik mb-6 text-black font-semibold dark:text-white">
										Social Media
									</p>
									<div>
										{socialLinks.map((link, index) => {
											if (!link.link) return null
											return (
												<a
													target="_blank"
													rel="noreferrer"
													href={link.link}
													className="flex items-center mb-4 hover:underline"
													key={`${link.linkItem + index}`}
												>
													<div className="flex items-center w-6 h-5">
														<FontAwesomeIcon
															icon={link.icon}
															key={`${link.icon + index}`}
															className="dark:text-slate-500"
														/>
													</div>
													<p className="text-base font-rubik text-gray-600 dark:text-gray-400">
														{link.linkItem}
													</p>
												</a>
											)
										})}
									</div>
								</>
							)}
						</div>
					</div>
				</div>
				<div className="text-gray-600 dark:text-gray-400 mb-5 flex flex-row">
					<div className="w-16">
						<EqualOpportunityHousingLogo />
					</div>
				</div>
				<div>
					<p className="text-xs font-rubik font-light text-gray-500 mb-5">
						{siteConfig && siteConfig.footerDisclaimerText1}
					</p>
					<p className="text-xs font-rubik font-light text-gray-500">
						{siteConfig && siteConfig.footerDisclaimerText2}
					</p>
				</div>
			</div>
		</div>
	)
}
